import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'newLineBreaker',
    standalone: false
})
export class NewLineBreakerPipe implements PipeTransform {
  transform(value: string | null): string | null {
    if (value) {
      return value.replace(new RegExp('\n', 'g'), '<br>')
    }
    return null
  }
}
